<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { PATHS } from '@/content'
import { isProPath } from '@/lib/section'

// Badge croise : sur le site Particuliers il invite a passer cote PRO ;
// sur une page PRO (theme sombre) il ramene vers le site Particuliers.
const route = useRoute()
const onPro = computed(() => isProPath(route.path))
const target = computed(() => (onPro.value ? '/' : PATHS.pro))
const label = computed(() =>
  onPro.value ? 'Espace professionnels' : 'Espace particuliers',
)
</script>

<template>
  <router-link
    :to="target"
    class="pro"
    :class="{ 'pro--invert': onPro }"
    :aria-label="onPro ? 'Retour au site Particuliers' : 'Espace professionnels'"
  >
    <span v-if="onPro">Vous êtes<br /><strong>PARTICULIER ?</strong><br />Cliquez ici</span>
    <span v-else>Vous êtes<br /><strong>PRO ?</strong><br />Cliquez ici</span>
  </router-link>
</template>

<style scoped>
.pro {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: var(--green);
  color: #272a23;
  text-align: center;
  font-size: 0.72rem;
  line-height: 1.35;
  text-transform: uppercase;
  font-family: var(--font-title);
  box-shadow: var(--shadow);
  transition: transform 0.15s, background 0.15s;
}
.pro:hover {
  background: var(--green-hover);
  transform: scale(1.05);
  text-decoration: none;
}
.pro strong {
  font-size: 1rem;
  font-weight: 800;
}
/* Sur page PRO sombre : garder le cercle vert lisible, contour clair. */
.pro--invert {
  background: var(--green);
  color: #14160f;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.5);
}
.pro--invert:hover {
  background: #b9db58;
  color: #14160f;
}
@media (max-width: 560px) {
  .pro {
    width: 74px;
    height: 74px;
    font-size: 0.6rem;
  }
  .pro strong {
    font-size: 0.82rem;
  }
}
</style>
